import { Modal, Input, Radio, Row, Col, Divider, Button, Switch, Alert } from "antd";
import React, { useEffect, useState, useRef } from "react";
import Capsat from "./CapsatModal";
import "../../../styles/components/modals.css";

function LineModal({ isModalOpen, handleOk, handleCancel, flussi, currentLang, addFlusso, isNew }) {
  const [currentData, setCurrentData] = useState({
    title: "",
    inputType: "",
    verdeMin: "",
    color: "#000000",
  });
  const [loading, setLoading] = useState(false);
  const [localFlussi, setLocalFlussi] = useState([]);
  const [showCapsat, setShowCapsat] = useState(false);
  const [forceResetCapsat, setForceResetCapsat] = useState(false);
  const [capSatResult, setCapSatResult] = useState(null);
  const isFirstCalcolo = useRef(false);
  const [isManual, setIsManual] = useState(false);
  const [validationError, setValidationError] = useState(null);

  useEffect(() => {
    if (!flussi || !Array.isArray(flussi)) return;

    const selectedFlusso = flussi.find(
      (f) => JSON.stringify(f.latlngs) === JSON.stringify(currentLang)
    );

    if (selectedFlusso) {
      const data = selectedFlusso.data || {};
      const capSat = data.capSatResult;
      const isSaved = data.saved;
      isFirstCalcolo.current = isNew || !isSaved || capSat == null;

      setCurrentData({
        title: data.title || "",
        inputType: data.inputType || "",
        verdeMin: data.verdeMin || "",
        color: data.color || "#000000",
      });

      if (!data.flussi || data.flussi.length === 0) {
        setLocalFlussi([{ id: 1, value: "" }]);
        setIsManual(false);
      } else {
        setLocalFlussi(data.flussi);
        setIsManual(data?.isManual || false);
      }

      if (capSat !== null && capSat !== undefined) {
        setCapSatResult(capSat);
      } else {
        setCapSatResult("");
      }
    }
  }, [flussi, currentLang, isNew]);

  const handleChange = (key, value) => {
    setCurrentData((prev) => ({ ...prev, [key]: value }));
    setValidationError(null);
  };

  const handleFlussoChange = (index, value) => {
    const updated = [...localFlussi];
    updated[index].value = value;
    setLocalFlussi(updated);
    setValidationError(null);
  };

  const validateForm = () => {
    if (currentData.inputType === "veicolare") {
      if (!localFlussi[0]?.value) {
        setValidationError("Flusso is required for veicolare input");
        return false;
      }
      if (!capSatResult && !isManual) {
        setValidationError("Please calculate or enter CapSat value");
        return false;
      }
    } else if (currentData.inputType === "pedonale") {
      if (!currentData.verdeMin) {
        setValidationError("Verde Minimo is required for pedonale input");
        return false;
      }
    }
    return true;
  };

  return (
    <Modal
      title="Inserisci le informazioni"
      confirmLoading={loading}
      open={isModalOpen}
      onOk={async () => {
        if (!validateForm()) {
          return;
        }
        
        setLoading(true);
        try {
          await handleOk({
            ...currentData,
            flussi: localFlussi,
            capSatResult: capSatResult,
            isManual: isManual
          });
          setValidationError(null);
        } finally {
          setLoading(false);
        }
      }}
      onCancel={() => {
        setValidationError(null);
        handleCancel();
      }}
      width={800}
      styles={{
        header: { className: "modal-brand-header" },
        footer: { className: "modal-brand-footer" }
      }}
    >
      {validationError && (
        <Alert
          message={validationError}
          type="error"
          showIcon
          className="line-modal-validation-alert"
        />
      )}

      <Row gutter={[16, 16]} className="line-modal-row">
        <Col span={16}><span className="line-modal-label">Nome manovra:</span></Col>
        <Col span={8}><Input value={currentData.title} onChange={(e) => handleChange("title", e.target.value)} size="small" className="line-modal-input" /></Col>
      </Row>

      <Radio.Group 
        value={currentData.inputType} 
        onChange={(e) => handleChange("inputType", e.target.value)} 
        className="line-modal-radio-group"
        buttonStyle="solid"
      >
        <Radio.Button value="veicolare">Input Veicolare</Radio.Button>
        <Radio.Button value="pedonale">Input Pedonale</Radio.Button>
      </Radio.Group>

      {currentData.inputType === "veicolare" && (
        <>
          <Row gutter={[16, 16]} align="middle" className="line-modal-row">
            <Col span={16}><span className="line-modal-label">Flusso:</span></Col>
            <Col span={8}><Input type="number" value={localFlussi[0]?.value || ""} onChange={(e) => handleFlussoChange(0, e.target.value)} size="small" className="line-modal-input" /></Col>
          </Row>

          <Row justify="space-between" align="middle" className="line-modal-row">
            <Col>
              <div className="line-modal-switch-container">
                <span className="line-modal-switch-label">Calcola CapSat manualmente</span>
                <Switch checked={isManual} onChange={() => {
                  handleChange("isManual", !isManual)
                  setIsManual(!isManual)
                }} />
              </div>
            </Col>
            <Col>
              {isManual ? (
                <Input 
                  value={capSatResult} 
                  onChange={(e) => {
                    handleChange("capSatResult", e.target.value)
                    setCapSatResult(e.target.value)
                  }}
                  className="line-modal-manual-input"
                  size="small"
                />
              ) : (
                <Button
                  type="primary"
                  className="line-modal-capsat-button"
                  onClick={() => {
                    setForceResetCapsat(true);
                    setShowCapsat(true);
                  }}
                >
                  Calcola CapSat
                </Button>
              )}
            </Col>
          </Row>

          {capSatResult !== null && capSatResult !== undefined && capSatResult !== "" && !isManual && (
            <Row gutter={[16, 16]} className="line-modal-row">
              <Col span={16}>
                <span className="line-modal-label">Risultato CapSat (veicoli/ora):</span>
              </Col>
              <Col span={8}>
                <Input value={String(capSatResult)} disabled size="small" className="line-modal-result-input" />
              </Col>
            </Row>
          )}
        </>
      )}

      {currentData.inputType === "pedonale" && (
        <Row gutter={[16, 16]} className="line-modal-row">
          <Col span={16}><span className="line-modal-label">Verde Minimo:</span></Col>
          <Col span={8}><Input type="number" value={currentData.verdeMin} onChange={(e) => handleChange("verdeMin", e.target.value)} size="small" className="line-modal-input" /></Col>
        </Row>
      )}

      <Divider className="line-modal-divider" />
      
      <Row gutter={[16, 16]}>
        <Col span={16}><span className="line-modal-label">Colore:</span></Col>
        <Col span={8}>
          <input 
            type="color" 
            value={currentData.color} 
            onChange={(e) => handleChange("color", e.target.value)} 
            className="line-modal-color-input"
          />
        </Col>
      </Row>

      <Modal 
        open={showCapsat} 
        onCancel={() => setShowCapsat(false)} 
        footer={null} 
        width={1000}
        styles={{
          header: { className: "modal-brand-nested-header" }
        }}
      >
        <Capsat
          key={currentLang ? JSON.stringify(currentLang) : "capsat"}
          onClose={() => setShowCapsat(false)}
          setCapSatResult={setCapSatResult}
          setCapacita={(val) => {
            setCapSatResult(val);
          }}
          isNewManovra={true}
        />
      </Modal>
    </Modal>
  );
}

export default LineModal;